const FACEBOOK_ORIGINS = new Set([
    'https://www.facebook.com',
    'https://web.facebook.com',
])

const SIGNUP_EXTRAS = {
    version: 'v4',
    featureType: 'whatsapp_business_app_onboarding',
    sessionInfoVersion: '3',
    setup: {
        business: {
            id: null,
            name: null,
            email: null,
            phone: { code: null, number: null },
            website: null,
            address: {
                streetAddress1: null,
                streetAddress2: null,
                city: null,
                state: null,
                zipPostal: null,
                country: null,
            },
            timezone: null,
        },
        phone: { displayName: null, category: null, description: null },
        preVerifiedPhone: { ids: null },
        solutionID: null,
        whatsAppBusinessAccount: { ids: null },
    },
}

let sdkPromise = null

const loadFacebookSdk = () => {
    if (window.FB) return Promise.resolve(window.FB)
    if (sdkPromise) return sdkPromise

    sdkPromise = new Promise((resolve, reject) => {
        const existing = document.getElementById('facebook-jssdk')
        const previousInit = window.fbAsyncInit
        window.fbAsyncInit = () => {
            if (typeof previousInit === 'function') previousInit()
            resolve(window.FB)
        }
        const fail = () => {
            sdkPromise = null
            reject(new Error('SDK_LOAD_FAILED'))
        }
        if (existing) {
            existing.addEventListener('error', fail, { once: true })
            return
        }
        const script = document.createElement('script')
        script.id = 'facebook-jssdk'
        script.async = true
        script.defer = true
        script.crossOrigin = 'anonymous'
        script.src = 'https://connect.facebook.net/pt_BR/sdk.js'
        script.onerror = fail
        document.head.appendChild(script)
    })
    return sdkPromise
}

const parseSessionEvent = event => {
    if (!FACEBOOK_ORIGINS.has(event.origin)) return null
    let payload = event.data
    if (typeof payload === 'string') {
        try {
            payload = JSON.parse(payload)
        } catch {
            return null
        }
    }
    if (!payload || payload.type !== 'WA_EMBEDDED_SIGNUP') return null
    return payload
}

const normalizedSession = payload => {
    const data = payload?.data || {}
    return {
        waba_id: String(data.waba_id || data.whatsapp_business_account_id || ''),
        phone_number_id: String(data.phone_number_id || data.phone_number_ids?.[0] || ''),
        business_id: data.business_id ? String(data.business_id) : null,
    }
}

const sessionEventName = payload => String(payload?.event || payload?.data?.event || '')

module.exports = {
    FACEBOOK_ORIGINS,
    SIGNUP_EXTRAS,
    loadFacebookSdk,
    normalizedSession,
    parseSessionEvent,
    sessionEventName,
}
